import timespace from "@mapbox/timespace";
import timezoneOffsetList from "../../_data/timezone_offsets.json";

const getTimeSince = timestamp => {
	const utcTime = Date.parse(timestamp); // parse may not work in edge/ie
	const nowSeconds = getUtcSecondsNow();
	return nowSeconds - utcTime;
};

const getUtcSecondsNow = () => {
	const date = new Date();
	return date.getTime() - (date.getTimezoneOffset() * 60000);
};

const formatTime = (isoTime) => {
	if (isoTime === null) {
		return "Unknown";
	}
	// e.g. "2020-08-04T05:21:00.410000+00:00"
	// cut the decimal until the +
	if (isoTime && isoTime.length === 32 && isoTime.indexOf("+00:00") > 0) {
		isoTime = isoTime.substr(0, 19);
	}
	if (isoTime && isoTime.length === 25) {
		isoTime = isoTime.substr(0, 19);
	}

	if (isoTime && isoTime.length === 19) { // ensure iso date
		return isoTime.replace("T", " ");
	}
	if (isoTime && isoTime.length === 20) { // ensure iso date
		return isoTime.replace("T", " ").replace("Z", " ");
	}
	return isoTime;
};
const formatUnixTimestamp = (unixTimestampSeconds) => {
	const d = new Date(unixTimestampSeconds * 1000);
	return d.toUTCString();
};

const calcLocalTimeFromPoint = (point) => {
	const rawLocalTime = timespace.getFuzzyLocalTimeFromPoint(Date.now(), point);
	if (typeof rawLocalTime === "undefined") {
		return null;
	}
	return (rawLocalTime.format("HH:mma") + " (" + rawLocalTime.format("ddd") + ")");
};

const getOneYearAgo = () => {
	const today = new Date();
	const oneYearAgo = new Date(
		today.getFullYear() - 1,
		today.getMonth(),
		today.getDate()
	);
	return oneYearAgo;
};
const getTwoYearsAgo = () => {
	const today = new Date();
	const twoYearsAgo = new Date(
		today.getFullYear() - 2,
		today.getMonth(),
		today.getDate()
	);
	return twoYearsAgo;
};
const getTwoYearsAgo1stJan = () => {
	const today = new Date();
	const twoYearsAgo = new Date(
		today.getFullYear() - 2,
		0,
		1
	);
	return twoYearsAgo;
};
const getTwoYearsAgoFudge = () => {
	const today = new Date();
	const twoYearsAgo = new Date(
		2018,
		11,
		20
	);
	return twoYearsAgo;
};
const generateHoursInAMonth = () => {
	const makeRelativeTimeOption = (value, num, unit) => {
		return { value, num, unit };
	};
	const relativeTimeOptions = [];
	for (let i = 1; i < 24; i++) {
		relativeTimeOptions.push(makeRelativeTimeOption(i, i, "hour"));
	}
	for (let i = 1; i < 7; i++) {
		relativeTimeOptions.push(makeRelativeTimeOption(i * 24, i, "day"));
	}
	for (let i = 1; i <= 4; i++) {
		relativeTimeOptions.push(makeRelativeTimeOption(i * 24 * 7, i, "week"));
	}
	return relativeTimeOptions;
};

const generateHoursInAMonthWindow = () => {
	const makeRelativeTimeOption = (value, num, unit) => {
		return { value, num, unit };
	};
	const relativeTimeOptions = [];
	for (let i = 4; i >= 1; i--) {
		relativeTimeOptions.push(makeRelativeTimeOption(-i * 24 * 7, i, "week"));
	}
	for (let i = 6; i >= 1; i--) {
		relativeTimeOptions.push(makeRelativeTimeOption(-i * 24, i, "day"));
	}
	for (let i = 24; i >= 1; i--) {
		relativeTimeOptions.push(makeRelativeTimeOption(-i, i, "hour"));
	}
	relativeTimeOptions.push(makeRelativeTimeOption(0, 0, ""));

	for (let i = 1; i < 24; i++) {
		relativeTimeOptions.push(makeRelativeTimeOption(i, i, "hour"));
	}
	for (let i = 1; i < 7; i++) {
		relativeTimeOptions.push(makeRelativeTimeOption(i * 24, i, "day"));
	}
	for (let i = 1; i <= 4; i++) {
		relativeTimeOptions.push(makeRelativeTimeOption(i * 24 * 7, i, "week"));
	}
	return relativeTimeOptions;
};

const canAdjustTimezoneToUTC = (mtime, rawTimezone, coords) => {
	if (!mtime.isValid()) {
		return false;
	}

	const timezoneKeys = timezoneOffsetList.map((item) => {
		return item.code;
	});
	const rawTimezoneIndex = timezoneKeys.indexOf(rawTimezone);
	if (rawTimezoneIndex === -1) {
		return false;
	}
	return true;
};
// does not alter mtime, it returns a new moment.
const adjustTimezoneToUTC = (mtime, rawTimezone, coords) => {
	const timezoneKeys = timezoneOffsetList.map((item) => {
		return item.code;
	});
	const rawTimezoneIndex = timezoneKeys.indexOf(rawTimezone);
	if (rawTimezoneIndex === -1) {
		return false;
	}

	const timezoneData = timezoneOffsetList[rawTimezoneIndex];
	const offset = timezoneData.offset.substr(3);
	const offsetMultiplier = (offset[0] === "+") ? 1 : -1;
	const offsetPeriods = offset.substr(1).split(":");
	const offsetHours = parseInt(offsetPeriods[0]);
	const offsetMinutes = parseInt(offsetPeriods[1]);
	// console.log("rawTimezone", rawTimezone);
	// console.log("offset by", offsetHours, offsetMinutes);
	if (offsetMultiplier === 1) {
		return mtime.clone().subtract(((offsetHours * 60) + offsetMinutes), "minutes");
	}
	else if (offsetMultiplier === -1) {
		return mtime.clone().add(((offsetHours * 60) + offsetMinutes), "minutes");
	}
};

export { getTimeSince, getUtcSecondsNow, formatTime, calcLocalTimeFromPoint, formatUnixTimestamp, getOneYearAgo, getTwoYearsAgo, getTwoYearsAgo1stJan, getTwoYearsAgoFudge, generateHoursInAMonth, generateHoursInAMonthWindow, canAdjustTimezoneToUTC, adjustTimezoneToUTC };
